import { Box, TextNew } from '@jfs/ui-new'
import { AlertDialog } from '../../screens/ProfileMobile/LogoutAlert'

interface ResendLinkAlertBoxInterface {
  isVisible: boolean
  onOkPress: () => void
  onCancelPress: () => void
  mobile: string
  email: string
  isLoading?: boolean
}

const ResendLinkAlertBox = ({
  isVisible,
  onOkPress,
  onCancelPress,
  mobile,
  email,
  isLoading = false,
}: ResendLinkAlertBoxInterface) => {
  interface renderTextViewInterface {
    text: string
  }

  const renderTextView = ({ text }: renderTextViewInterface) => {
    return (
      <Box pv={5}>
        <TextNew type={'link12'} color="BLACK_21" fontWeight="MEDIUM" title={text} />
      </Box>
    )
  }

  // const renderInfo = () => {
  //   return (
  //     <Box pt={12} flexDirection="row">
  //       <Icon id="INFO" color="LIGHT_BLACK" size={14} />
  //       <Box justifyContent="center" pl={10}>
  //         <TextNew type={'link12'} color="LIGHT_BLACK">
  //           {"The payment link can't be edited after sending"}
  //         </TextNew>
  //       </Box>
  //     </Box>
  //   )
  // }

  const renderCustomElements = (mobileNum: string, emailId: string) => {
    return (
      <Box pt={15}>
        {renderTextView({ text: mobileNum })}
        {renderTextView({ text: emailId })}
        {/* {renderInfo()} */}
      </Box>
    )
  }
  return (
    <AlertDialog
      visible={isVisible}
      onCancelPress={onCancelPress}
      onOkPress={onOkPress}
      type={'CancelLink'}
      negativeLabel={'Send Link'}
      positiveLabel={'Cancel'}
      title={'Resend Link'}
      subTitle={'The payment link will be sent to'}
      renderCustomComponent={() => renderCustomElements(mobile, email)}
      isCancelLoading={isLoading}
    />
  )
}

export { ResendLinkAlertBox }
